import Contact from '../components/Contact';

const Footer = () => {
    return (
        <footer>
            <Contact />
        </footer>
    )
}

export default Footer